module.exports = __webpack_public_path__ + "media/packs/base/stylesheets/fonts/apercu-regular-pro-2333a1d21f530639dd033e144c5fd2fb.woff2";